export const config = process.env;

export const DOMAIN_URL = 'http://' + config.REACT_APP_DOMAIN + ':' + config.REACT_APP_PORT;
